$(document).ready(function(){

  if( $('.shopify-section.productrecommendations .slider').length ){ // recommendations slider
    $('.shopify-section.productrecommendations .slider').slick({
      mobileFirst: true,
      prevArrow: '',
      nextArrow: $('.shopify-section.productrecommendations .next'),
      dots: false,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          }
        }
      ]
    }).show();
  }

  // var url = new URLSearchParams(location.search);
  // if( url.get("utm_campaign").includes('24-11-23 BF OFFICIAL BLACK FRIDAY') ){
  //   $('.product:not(.cta)').each(function(){
  //     var new_href = $(this).find('a').attr('href').split('?')[0] + '?freegift=7882192978118';
  //     $(this).find('a').attr('href', new_href);
  //   });
  // }

  if( $('.filters').length ){ // filter by
    $('select#colour').change(function(){
      window.location.href = $(this).val();
    });

    $('.product-list:not(.offcanvas_list)').isotope({
      // options
      itemSelector: '.product',
      layoutMode: 'fitRows'
    });

    $('.filter').change(function(){
      $('.filter').not( $(this) ).val('.all');
      $('.product-list:not(.offcanvas_list)').isotope({ filter: $(this).val() });

      $('html,body').animate({
        scrollTop: $('.product-list:not(.offcanvas_list)').offset().top - 80
      }, 1000);

      gtag("event", "filters_used");
    });
  }


  // // intelligems pricing structure
  window.addEventListener('ig:ready', () => {

    var discount = shop_config.discount_percent / 100;
    $('.product-list .product:not(.cta)').each(function(){
      var variant_id = parseInt($(this).find('.product-item').attr('variant_id'));
      var price = parseFloat( window.igData.price.getPriceByVariantId(variant_id));
      var savings = parseFloat(price * discount ).toFixed(2);

      var updated_price = parseFloat( price - savings ).toFixed(2);

      var format = shop_config.money_format;
      if( window.igData.price.getPriceByVariantId(variant_id) != null ){
        $(this).find('.product-item-price-final').text(format.replace('{'+ '{amount_with_comma_separator}'+'}', updated_price ));
      }
    });
    
  });
});
